import { layerConfig } from "../fetchLayerConfig";
import { debugLog } from "../debugLog";
import { filterGameEvent } from "./filterGameEvent";
import { addIdToResolve, resolveIdAndRequireAll, waitUntilAllResolved } from "./idResolving";
import { checkBusyState } from "./busyState";
const verifiers = {
    ["pause-when-idle"]: [waitUntilAllResolved("busy-state")],
    ["idle-paused"]: [addIdToResolve("pauses")],
    ["pause-resume"]: [resolveIdAndRequireAll("pauses"), waitUntilAllResolved("busy-state")],
    ["freeze"]: [addIdToResolve("pauses")],
    ["unfreeze"]: [resolveIdAndRequireAll("pauses")],
    ["error-message-dismissed"]: [waitUntilAllResolved("pauses")],
    ["report-ui-state"]: [checkBusyState("busy-state")]
};
export const verifyEvent = (event, payload, source) => {
    if (filterGameEvent(event, source)) {
        debugLog("Filtered event " + event);
        return [false];
    }
    if (layerConfig.disableMultiPause === true) {
        return [true];
    }
    const eventVerifiers = verifiers[event];
    if (eventVerifiers === undefined) {
        return [true];
    }
    const promises = eventVerifiers.reduce((acc, verifier) => {
        const result = verifier(payload);
        if (typeof result === "boolean") {
            acc.push(Promise.resolve(result));
        }
        else {
            acc.push(result);
        }
        return acc;
    }, []);
    return Promise.all(promises);
};
